import { Col, Container, Row, Button } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

// components
import { FormInput } from '../form';
import SwiperSlider5 from '../sliders/SwiperSlider5';
import { Link } from 'react-router-dom';
import Swiper, { Autoplay } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { colors } from 'styles/colors';





const Hero12 = () => {
    return (
        // <section >

        <div >
            {/* <SwiperSlider5 /> */}
            <section className="relative overflow-hidden" style={{ backgroundColor: "#24347D" }}>

                <div className="absolute inset-0 bg-gradient-to-br from-[#24347D] via-[#26458D] to-[#26A2AB]"></div>


                <div className="absolute inset-0 opacity-10">
                    <svg className="h-full w-full" viewBox="0 0 1200 600" preserveAspectRatio="none">
                        <path d="M0,420 C200,360 280,520 520,460 C760,400 820,520 1200,430 L1200,600 L0,600 Z" fill="white" />
                    </svg>
                </div>


                <div className="absolute left-0 top-0 h-96 w-96 animate-pulse rounded-full bg-[#26A2AB]/20 blur-3xl"></div>
                <div className="absolute bottom-0 right-0 h-96 w-96 animate-pulse rounded-full bg-[#24347D]/40 blur-3xl"></div>

                <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-4 lg:px-6 lg:py-18">
                    <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">

                        {/* Left Content */}
                        <div className="text-white">
                            {/* Badge */}
                            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 backdrop-blur-sm">
                                <span className="h-2 w-2 rounded-full bg-[#26A2AB]"></span>
                                <span className="text-sm font-medium tracking-wide">AI-powered CRM for SMBs</span>
                            </div>

                            {/* Headline */}
                            <h1 className="mt-3 text-4xl font-bold leading-tight text-white tracking-tight sm:text-5xl lg:text-6xl">
                                Track Sales. Boost Revenue.
                                <span className="mt-2 block bg-gradient-to-r from-[#26A2AB] to-[#9194a0] bg-clip-text text-transparent">
                                    Automate Your Growth.
                                </span>
                            </h1>

                            {/* Description */}
                            <p className="mt-4 max-w-xl text-lg text-white/80">
                                SalesTrackify helps you manage leads, close deals, and automate workflows with AI—so your team spends less
                                time on admin and more time winning.
                            </p>

                            {/* CTA Section */}
                            <div className="mt-5 flex flex-col gap-4 sm:flex-row sm:items-center">
                                <div className=" items-center overflow-hidden rounded-xl bg-white p-1 shadow-xl">
                                    {/* <input
                                            type="email"
                                            placeholder="Enter your email"
                                            className="w-full px-4 py-3 text-sm text-slate-900 outline-none placeholder:text-slate-400"
                                        /> */}
                                    {/* <button
                                            className="whitespace-nowrap rounded-lg px-9 py-3 text-sm font-semibold text-white transition-all hover:opacity-90"
                                            style={{ backgroundColor: "#26A2AB" }}
                                        >
                                        Book a Demo
                                        </button> */}
                                    <Link
                                        to="/contact"
                                        className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold transition-all hover:scale-105 shadow-lg"
                                        style={{
                                            backgroundColor: "#26A2AB",
                                            color: "white"
                                        }}
                                    >
                                        Book a Demo
                                    </Link>

                                    {/* <div className="mt-4 flex flex-col justify-center gap-4 sm:flex-row">
                                                                    <Link
                                                                        to="/contact"
                                                                        className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold transition-all hover:scale-105 shadow-lg"
                                                                        style={{
                                                                            backgroundColor: "#26A2AB",
                                                                            color: "white"
                                                                        }}
                                                                    >
                                                                        Book a Demo
                                                                    </Link>
                                        
                                                                </div> */}
                                </div>

                                {/* <a
                                        href="#"
                                        className="inline-flex items-center justify-center rounded-xl border border-white/30 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
                                    >
                                        <svg className="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M8 5v14l11-7z" />
                                        </svg>
                                        Watch demo
                                    </a> */}
                            </div>

                            {/* Stats */}
                            <div className="mt-5 grid max-w-xl grid-cols-3 gap-4">
                                {[
                                    { value: "1,000+", label: "Businesses" },
                                    { value: "10M+", label: "Leads managed" },
                                    { value: "99.9%", label: "Uptime" }
                                ].map((stat, idx) => (
                                    <div key={idx} className="rounded-2xl bg-white/5 p-4 backdrop-blur-sm">
                                        <p className="text-xl font-bold text-white">{stat.value}</p>
                                        <p className="text-xs text-white/60">{stat.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Right Content - Dashboard Card */}
                        <div className="relative">
                            {/* Main Card */}
                            <div className="rounded-3xl bg-white/95 p-4 shadow-2xl backdrop-blur-sm">
                                {/* Card Header */}
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <div className="h-3 w-3 rounded-full" style={{ backgroundColor: "#26A2AB" }}></div>
                                        <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
                                        <div className="h-3 w-3 rounded-full bg-red-500"></div>
                                        <span className="ml-2 text-sm font-medium text-slate-600">Dashboard</span>
                                    </div>
                                    <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-600">This week</span>
                                </div>

                                {/* KPI Grid */}
                                <div className="mt-3 grid grid-cols-3 gap-3">
                                    {[
                                        { label: "Pipeline", value: "$87,230" },
                                        { label: "New Leads", value: "52" },
                                        { label: "Conversion", value: "21.5%" }
                                    ].map((kpi, idx) => (
                                        <div key={idx} className="rounded-xl bg-slate-50 p-3">
                                            <p className="text-xs text-slate-500">{kpi.label}</p>
                                            <p className="mt-1 text-lg font-bold text-slate-900">{kpi.value}</p>
                                        </div>
                                    ))}
                                </div>

                                {/* Sales Growth Chart */}
                                <div className="mt-3 rounded-xl bg-slate-50 p-5">
                                    {/*   <div className="flex items-center justify-between">
                                            <p className="text-sm font-semibold text-slate-800">Sales Growth</p>
                                            <span className="flex items-center gap-1 text-xs font-semibold" style={{ color: "#26A2AB" }}>
                                                <span>↑</span> Trending
                                            </span>
                                        </div>

                                     <div className="mt-4 flex h-40 items-end gap-2">
                                            {[30, 45, 50, 65, 75, 85, 95].map((height, idx) => (
                                                <div
                                                    key={idx}
                                                    className="group relative flex-1 cursor-pointer transition-all hover:scale-105"
                                                >
                                                    <div
                                                        className="absolute -top-8 left-1/2 hidden -translate-x-1/2 rounded bg-slate-800 px-2 py-1 text-xs text-white group-hover:block"
                                                    >
                                                        {height}%
                                                    </div>
                                                    <div
                                                        className={`w-full rounded-t-lg ${idx === 6
                                                            ? 'bg-gradient-to-t from-[#26A2AB] to-[#24347D]'
                                                            : 'bg-gradient-to-t from-[#26A2AB]/60 to-[#24347D]/60'
                                                            }`}
                                                        style={{ height: `${height}%` }}
                                                    ></div>
                                                </div>
                                            ))}
                                        </div> */}

                                    <div className="mt-0 rounded-xl bg-slate-50 p-0">
                                        <div className="flex items-center justify-between mb-4">
                                            <p className="text-sm font-semibold text-slate-800">Sales Growth</p>
                                            <span className="flex items-center gap-1 text-xs font-semibold" style={{ color: "#26A2AB" }}>
                                                <span>↑</span> Trending
                                            </span>
                                        </div>

                                        {/* Fixed Chart Container */}
                                        <div className="flex h-40 items-end justify-between gap-1">
                                            {/* Bar 1 - 30% */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    30%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '30%' }}></div>
                                            </div>

                                            {/* Bar 2 - 45% */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    45%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '45%' }}></div>
                                            </div>

                                            {/* Bar 3 - 50% */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    50%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '50%' }}></div>
                                            </div>

                                            {/* Bar 4 - 65% */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    65%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '65%' }}></div>
                                            </div>

                                            {/* Bar 5 - 75% */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    75%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '75%' }}></div>
                                            </div>

                                            {/* Bar 6 - 85% */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    85%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '85%' }}></div>
                                            </div>

                                            {/* Bar 7 - 95% (Highlighted) */}
                                            <div className="relative flex h-full w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    95%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '95%' }}></div>
                                            </div>
                                        </div>

                                        {/* X-axis labels (optional) */}
                                        <div className="flex justify-between gap-1 mt-2">
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Mon</span>
                                            </div>
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Tue</span>
                                            </div>
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Wed</span>
                                            </div>
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Thu</span>
                                            </div>
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Fri</span>
                                            </div>
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Sat</span>
                                            </div>
                                            <div className="w-8 text-center">
                                                <span className="text-xs text-slate-500">Sun</span>
                                            </div>
                                        </div>
                                    </div>



                                </div>

                                {/* Bottom Grid */}
                                <div className="mt-3 grid gap-4 sm:grid-cols-2">
                                    {/* Top Deals */}
                                    <div className="rounded-xl bg-slate-50 p-3">
                                        <p style={{ color: colors.primary.teal }} className="text-sm font-semibold text-slate-800">Top Deals</p>
                                        <div className="mt-2 space-y-3">
                                            {[
                                                { name: "Acme Inc.", value: "$8,300" },
                                                { name: "Delta Corp", value: "$4,200" },
                                                { name: "Stark Solutions", value: "$3,900" }
                                            ].map((deal, idx) => (
                                                <div key={idx} className="flex items-center justify-between">
                                                    <span className="text-sm text-slate-600">{deal.name}</span>
                                                    <span className="text-sm font-semibold text-slate-900">{deal.value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Upcoming Tasks */}
                                    <div className="rounded-xl bg-slate-50 p-3">
                                        <p style={{ color: colors.primary.teal }} className="text-sm font-semibold text-slate-800">Upcoming Tasks</p>
                                        <div className="mt-2 space-y-3">
                                            {[
                                                { task: "Follow-up email", tag: "Today", color: "text-[#26A2AB] bg-[#26A2AB]/10" },
                                                { task: "Demo call", tag: "Tomorrow", color: "text-[#24347D] bg-[#24347D]/10" },
                                                { task: "Send quote", tag: "This week", color: "text-slate-600 bg-slate-100" }
                                            ].map((item, idx) => (
                                                <div key={idx} className="flex items-center justify-between">
                                                    <span className="text-sm text-slate-600">{item.task}</span>
                                                    <span className={`rounded-full px-2 py-0 text-xs font-medium`}
                                                        style={item.color.includes('bg-') ? {} : {
                                                            color: item.tag === 'Today' ? '#26A2AB' : '#24347D',
                                                            backgroundColor: item.tag === 'Today' ? '#26A2AB10' : '#24347D10'
                                                        }}>
                                                        {item.tag}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>


        // </section>
    );
};

export default Hero12;





